const CustomSize = {
    fontLarge: '32px',
    fontSmall: '14px'
}

export default CustomSize;